module.exports = __webpack_public_path__ + "assets/img/agi.b09db58a.png";